import { Art } from "../../assets";

export const SvgLink = [
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__shopping-basket"
    width="20"
    height="20"
    viewBox="0 0 22.903 21.001"
  >
    <g id="prefix__Group_14" data-name="Group 14">
      <path
        id="prefix__Path_5"
        d="M289.928 25.759h2.008l-2.976-5.106a.866.866 0 1 0-1.5.875z"
        className="prefix__cls-13"
        data-name="Path 5"
        transform="translate(-273.834 -20.222)"
        fill="#fff"
      ></path>
      <path
        id="prefix__Path_6"
        d="M106.771 21.57a.866.866 0 1 0-1.5-.875l-2.971 5.111h2.008z"
        className="prefix__cls-13"
        data-name="Path 6"
        transform="translate(-97.49 -20.265)"
        fill="#fff"
      ></path>
      <path
        id="prefix__Path_7"
        d="M21.427 171.278H1.472A1.471 1.471 0 0 0 0 172.75v1.632a1.471 1.471 0 0 0 1.472 1.472h.461l1.42 7.7a2.017 2.017 0 0 0 1.867 1.627h12.168a2.017 2.017 0 0 0 1.867-1.627l1.429-7.7h.748a1.471 1.471 0 0 0 1.472-1.472v-1.632a1.477 1.477 0 0 0-1.477-1.472zm-13.3 7.692v3.32a.832.832 0 0 1-1.664 0v-4.655a.832.832 0 1 1 1.664 0zm2.671 0v3.32a.832.832 0 0 1-1.664 0v-4.655a.831.831 0 0 1 .832-.832.849.849 0 0 1 .832.832zm2.682 1.93v1.392a.832.832 0 0 1-1.664 0v-4.655a.849.849 0 0 1 .832-.832.831.831 0 0 1 .832.832zm2.671 0v1.392a.832.832 0 0 1-1.664 0v-4.655a.832.832 0 1 1 1.664 0z"
        className="prefix__cls-13"
        data-name="Path 7"
        transform="translate(0 -164.175)"
        fill="#fff"
      ></path>
    </g>
  </svg>,
];

export const Data = [
  {
    id: "1",
    dlink: Art,
    dproductimage: Art,
    dimagelink: "https://artbyraff.com/product/untitled-202iii-series-9/",
    dproductname: "Untitled 202III - Series",
    dprice: "Sold",
    dproductinfo: "MATERIAL : MIXED MEDIA ON CANVAS",
    dsize: "100 x 100 cm",
    dsvg: SvgLink,
  },
  {
    id: "2",
    dlink: "https://artbyraff.com/product/untitled-202iii-series-8/",
    dproductimage: Art,
    dimagelink: "https://artbyraff.com/product/untitled-202iii-series-8/",
    dproductname: "Untitled 202III - Series",
    dprice: "SOLD",
    dproductinfo: "MATERIAL : MIXED MEDIA ON CANVAS",
    dsize: "100 X 100 CM",
  },
  {
    id: "3",
    dlink: "https://artbyraff.com/product/untitled-202iii-series-7/",
    dproductimage: Art,
    dimagelink: "https://artbyraff.com/product/untitled-202iii-series-7/",
    dproductname: "UNTITLED 202III - SERIES",
    dprice: "€3,250.00",
    dproductinfo: "MATERIAL : MIXED MEDIA ON CANVAS",
    dsize: "80 X 100CM",
    dsvg: SvgLink,
  },
  {
    id: "4",
    dlink: "https://artbyraff.com/product/untitled-202iii-series-6/",
    dproductimage: Art,
    dimagelink: "https://artbyraff.com/product/untitled-202iii-series-6/",
    dproductname: "UNTITLED 202III – SERIES",
    dprice: "€3,250.00",
    dproductinfo: "MATERIAL : MIXED MEDIA ON CANVAS",
    dsize: "80 X 100CM",
    dsvg: SvgLink,
  },
  {
    id: "5",
    dlink: "https://artbyraff.com/product/untitled-202iii-series-5/",
    dproductimage: Art,
    dimagelink: "https://artbyraff.com/product/untitled-202iii-series-5/",
    dproductname: "UNTITLED 202III – SERIES",
    dprice: "SOLD",
    dproductinfo: "MATERIAL : MIXED MEDIA ON CANVAS",
    dsize: "80 X 100CM",
  },
  {
    id: "6",
    dlink: "https://artbyraff.com/product/untitled-202iii-series-4/",
    dproductimage: Art,
    dimagelink: "https://artbyraff.com/product/untitled-202iii-series-4/",
    dproductname: "UNTITLED 202III – SERIES",
    dprice: "SOLD",
    dproductinfo: "MATERIAL : MIXED MEDIA ON CANVAS",
    dsize: "80 X 100CM",
  },
  {
    id: "7",
    dlink: "https://artbyraff.com/product/untitled-202iii-series-3/",
    dproductimage: Art,
    dimagelink: "https://artbyraff.com/product/untitled-202iii-series-3/",
    dproductname: "UNTITLED 202III – SERIES",
    dprice: "€3,250.00",
    dproductinfo: "MATERIAL : MIXED MEDIA ON CANVAS",
    dsize: "80 X 100CM",
    dsvg: SvgLink,
  },
  {
    id: "8",
    dlink: "https://artbyraff.com/product/untitled-202iii-series-2/",
    dproductimage: Art,
    dimagelink: "https://artbyraff.com/product/untitled-202iii-series-2/",
    dproductname: "UNTITLED 202III – SERIES",
    dprice: "€3,250.00",
    dproductinfo: "MATERIAL : MIXED MEDIA ON CANVAS",
    dsize: "80 X 100CM",
    dsvg: SvgLink,
  },
  {
    id: "9",
    dlink: "https://artbyraff.com/product/untitled-202iii-series-1/",
    dproductimage: Art,
    dimagelink: "https://artbyraff.com/product/untitled-202iii-series-1/",
    dproductname: "UNTITLED 202III – SERIES",
    dprice: "€3,250.00",
    dproductinfo: "MATERIAL : MIXED MEDIA ON CANVAS",
    dsize: "80 X 100CM",
    dsvg: SvgLink,
  },
];

export const SData = [
  {
    id: "1",
    dlink: "https://artbyraff.com/product/untitled-4/",
    dproductimage: Art,
    dimagelink: "https://artbyraff.com/product/untitled-4/",
    dproductname: "“ UNTITLED “",
    dprice: "€1,300.00",
    dproductinfo: "ACRYL, SPRAY, PLASTER",
  },
  {
    id: "2",
    dlink: "https://artbyraff.com/product/warhol-basquiat-table-1-of-1/",
    dproductimage: Art,
    dimagelink: "https://artbyraff.com/product/warhol-basquiat-table-1-of-1/",
    dproductname: "“ WARHOL & BASQUIAT “ -TABLE 1 OF 1",
    dprice: "",
    dproductinfo: "ACRYL, PENCIL, SPRAY, ON WOOD",
  },
];
